import React, { useState } from "react";

export function ImpersonationLogTab({ rows }) {
  const [q, setQ] = useState("");
  const filtered = rows.filter((r) => {
    if (!q.trim()) return true;
    const needle = q.trim().toLowerCase();
    return (
      (r.admin_email || "").toLowerCase().includes(needle) ||
      (r.target_email || "").toLowerCase().includes(needle)
    );
  });
  return (
    <div className="space-y-4" data-testid="impersonation-log">
      <div className="flex items-center gap-3">
        <input
          className="underline-input mono max-w-md"
          placeholder="Filter by admin or customer email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="imp-log-filter"
        />
        <span className="text-xs text-[#4A5C50]">{filtered.length} of {rows.length}</span>
      </div>
      <div className="bg-white border border-[#E5E0D8] rounded-2xl overflow-hidden">
        <table className="w-full text-sm" data-testid="imp-log-table">
          <thead className="text-left text-[#4A5C50] text-xs uppercase tracking-widest">
            <tr>
              <th className="p-4">When</th>
              <th className="p-4">Admin</th>
              <th className="p-4">Viewed as</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={3} className="p-6 text-[#4A5C50]">No impersonation events recorded.</td></tr>
            )}
            {filtered.map((r) => (
              <tr key={r.id} className="border-t border-[#E5E0D8]" data-testid={`imp-log-row-${r.id}`}>
                <td className="p-4 mono text-xs">{new Date(r.ts).toLocaleString()}</td>
                <td className="p-4 mono text-xs">{r.admin_email}</td>
                <td className="p-4 mono text-xs">{r.target_email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
